import { some } from 'es-toolkit/compat';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { SideBar } from '@oliasoft-open-source/react-ui-library';
import {
  isActiveRoute,
  generatePath,
  navigateToPath,
} from 'client/store/navigation/navigation';
import {
  TbDatabaseSearch, TbChartLine, TbLock, TbFolderSearch, TbCheckbox, TbFile,
} from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';
import { routes } from '../routes/routes';

interface SectionItem {
  label: string;
  activePaths?: Array<object>;
  path: object;
  icon: ReactNode;
  value: string;
  params?: any;
}

interface Section {
  heading: string;
  items: SectionItem[];
}

interface IProjectSideBar {
  navigateToPath: Function;
}

const ProjectSideBar = ({ navigateToPath }: IProjectSideBar) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { companyId } = useParams();

  const sections: Section[] = [
    {
      heading: 'Atlas',
      items: [
        {
          label: t(translations.explore),
          path: routes.explore,
          icon: <TbFolderSearch />,
          value: '',
        },
        {
          label: t(translations.companyData),
          path: routes.companyData,
          icon: <TbFile />,
          value: '',
        },
        {
          label: t(translations.query),
          path: routes.query,
          icon: <TbDatabaseSearch />,
          value: '',
        },
        {
          label: t(translations.taskManager),
          path: routes.taskManager,
          icon: <TbCheckbox />,
          value: '',
        },
        {
          label: t(translations.analytics),
          path: routes.analytics,
          icon: <TbChartLine />,
          value: '',
        },
        {
          label: t(translations.accessManagement),
          path: routes.accessManagement,
          icon: <TbLock />,
          value: '',
        },
      ],
    },
  ];

  return (
    <SideBar
      top={48}
      options={{
        title: '',
        sections: sections.map((section) => ({
          ...section,
          items: section.items.map((item) => ({
            ...item,
            isActive: item?.activePaths
              ? some(item?.activePaths.map((p) => isActiveRoute(p, pathname)))
              : isActiveRoute(item.path, pathname),
            onClick: () => navigateToPath(
              generatePath(item.path, {
                companyId,
              }, true),
            ),
          })),
        })),
      }}
    />
  );
};

const mapDispatchToProps = {
  navigateToPath,
};

const Container = connect(null, mapDispatchToProps)(ProjectSideBar);

export { Container as ProjectSideBar };
